import { Component, OnInit, ViewChild} from '@angular/core';
import { ModalDirective } from 'angular-bootstrap-md';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  @ViewChild('basicModal', {static: false})basicModal: ModalDirective;

  showmodal() {
    this.basicModal.show();
  }
}
